import {memo, useEffect} from "react";
import {useLocation} from "react-router-dom";
import {getOpenGraphMeta} from "@/config/openGraph";
import {getLangFromPath} from "@/utils/lang";
import {applyOpenGraphMeta} from "@/utils/updateMetaTags";

const OpenGraph = () => {
    const {pathname} = useLocation();
    const lang = getLangFromPath(pathname);

    useEffect(() => {
        applyOpenGraphMeta(getOpenGraphMeta(lang, pathname));
    }, [lang, pathname]);

    return null;
};

export default memo(OpenGraph);
